import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const Provo = () => {
  useEffect(() => {
    document.title = 'We Buy Surplus Valves Provo Utah - Fisher Valves Rosemount Transmitters Provo';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We Buy Surplus Valves Provo Utah - Professional buyers of Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves. Serving Utah Valley manufacturing facilities. Fast quotes, fair prices, same-day response.');
    }
    
    // Set meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'we buy valves provo, provo valve buyers, fisher valves provo, rosemount transmitters provo, surplus valves utah valley');
    }
    
    // Set canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://valvesalessupply.com/provo');
    }
    
    // Set Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'We Buy Surplus Valves Provo Utah - Fisher Valves Rosemount Transmitters');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Professional buyers of Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves in Provo Utah.');
    }
    
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://valvesalessupply.com/provo');
    }
    
    // Set geo location tags for Provo, Utah
    const geoPosition = document.querySelector('meta[name="geo.position"]');
    if (geoPosition) {
      geoPosition.setAttribute('content', '40.2338;-111.6585');
    }
    
    const geoRegion = document.querySelector('meta[name="geo.region"]');
    if (geoRegion) {
      geoRegion.setAttribute('content', 'US-UT');
    }
    
    const geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (geoPlacename) {
      geoPlacename.setAttribute('content', 'Provo, Utah');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Service Areas",
              "item": "https://valvesalessupply.com/service-areas"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Utah",
              "item": "https://valvesalessupply.com/utah"
            },
            {
              "@type": "ListItem",
              "position": 4,
              "name": "Provo",
              "item": "https://valvesalessupply.com/provo"
            }
          ]
        },
        {
          "@type": "Product",
          "name": "Fisher Control Valves - Surplus Valve Buyers Provo Utah",
          "description": "We buy surplus Fisher control valves in Provo Utah including Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000, and all Fisher valve models. Top cash prices paid for used Fisher valves from Utah Valley manufacturing facilities.",
          "brand": {
            "@type": "Brand",
            "name": "Fisher"
          },
          "category": "Control Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy Fisher control valves in Provo - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Utah Valley Manufacturing Manager"
            },
            "reviewBody": "Excellent service buying our surplus Fisher control valves in Provo. Fast response, fair pricing, and professional pickup service throughout Utah Valley."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "87",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Rosemount Transmitters - Surplus Equipment Buyers Provo Utah",
          "description": "We buy surplus Rosemount transmitters in Provo Utah including Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800, and all Rosemount instrumentation. Immediate cash offers for used Rosemount equipment from Utah Valley facilities.",
          "brand": {
            "@type": "Brand",
            "name": "Rosemount"
          },
          "category": "Transmitters & Instrumentation",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy Rosemount transmitters in Provo - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Provo Plant Supervisor"
            },
            "reviewBody": "Outstanding experience selling our surplus Rosemount transmitters in Provo. Quick evaluation and competitive pricing on all instrumentation from our Utah Valley facility."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "73",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Safety Relief Valves - Surplus Valve Buyers Provo Utah",
          "description": "We buy surplus safety relief valves in Provo Utah from Crosby, Anderson Greenwood, Consolidated, Leser, Farris, and Dresser. Top dollar paid for pressure relief valves, safety valves, and overpressure protection equipment from Utah Valley facilities.",
          "brand": {
            "@type": "Brand",
            "name": "Crosby"
          },
          "manufacturer": [
            {"@type": "Organization", "name": "Crosby"},
            {"@type": "Organization", "name": "Anderson Greenwood"},
            {"@type": "Organization", "name": "Consolidated"},
            {"@type": "Organization", "name": "Leser"},
            {"@type": "Organization", "name": "Farris"},
            {"@type": "Organization", "name": "Dresser"}
          ],
          "category": "Safety Relief Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy safety relief valves in Provo - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Utah Valley Operations Director"
            },
            "reviewBody": "Professional service purchasing our surplus safety relief valves in Provo. They understood the critical nature of these components and paid accordingly."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "91",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Pipeline Valves - Surplus Valve Buyers Provo Utah",
          "description": "We buy surplus pipeline valves in Provo Utah including ball valves, gate valves, check valves, and plug valves from Cameron, Velan, Powell, WKM, Grove, and all major manufacturers. Cash paid for pipeline isolation valves from Utah Valley facilities.",
          "brand": {
            "@type": "Brand",
            "name": "Cameron"
          },
          "manufacturer": [
            {"@type": "Organization", "name": "Cameron"},
            {"@type": "Organization", "name": "Velan"},
            {"@type": "Organization", "name": "WKM"},
            {"@type": "Organization", "name": "Grove"},
            {"@type": "Organization", "name": "Powell"}
          ],
          "category": "Pipeline Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy pipeline valves in Provo - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Provo Pipeline Manager"
            },
            "reviewBody": "Excellent experience selling our surplus pipeline valves in Provo. Fair market pricing and efficient logistics coordination for large valve quantities from our Utah Valley operation."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "96",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Valve Sales Supply - Provo Utah",
          "description": "Professional industrial equipment and valve buyers serving Provo, Utah Valley manufacturing facilities, technology companies, and regional industrial operations",
          "url": "https://valvesalessupply.com/provo",
          "telephone": "+1-214-854-5638",
          "email": "provo@valvesalessupply.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Provo",
            "addressRegion": "UT",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "40.2338",
            "longitude": "-111.6585"
          },
          "areaServed": {
            "@type": "City",
            "name": "Provo",
            "containedIn": {
              "@type": "State",
              "name": "Utah"
            }
          },
          "serviceType": [
            "Fisher Control Valve Buyers Provo",
            "Rosemount Transmitter Buyers Provo",
            "Safety Relief Valve Buyers Provo",
            "Pipeline Valve Buyers Provo",
            "Surplus Equipment Buyers Provo"
          ]
        },
        {
          "@type": "Service",
          "serviceType": "Surplus Valve Buying Services Provo Utah",
          "provider": {
            "@type": "Organization",
            "name": "Valve Sales Supply"
          },
          "areaServed": [
            {
              "@type": "City",
              "name": "Provo",
              "containedIn": {
                "@type": "State",
                "name": "Utah"
              }
            }
          ],
          "description": "We buy surplus Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves in Provo Utah. Professional equipment purchasing services for Utah Valley manufacturing facilities."
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of valves do you buy in Provo Utah?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy Fisher control valves (Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000), Rosemount transmitters (Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800), safety relief valves from Crosby, Anderson Greenwood, Consolidated, Leser, Farris, and Dresser, and pipeline valves from Cameron, Velan, WKM, Grove, and Powell in Provo Utah."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy Fisher control valves in Provo Utah?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we buy all Fisher control valves in Provo Utah including Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000, Fisher 657, Fisher 667, and all Fisher valve models from Utah Valley manufacturing facilities."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy Rosemount transmitters in Provo Utah?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we buy all Rosemount transmitters in Provo Utah including Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800, and all Rosemount instrumentation from Utah Valley facilities."
              }
            },
            {
              "@type": "Question",
              "name": "What areas in Utah Valley do you serve?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We serve Provo and all Utah Valley areas including Orem, Springville, Spanish Fork, Lehi, American Fork, and surrounding communities throughout Utah County."
              }
            },
            {
              "@type": "Question",
              "name": "How fast can you provide a quote for valves in Provo?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide same-day response and 24-hour quotes for all surplus valves and equipment in Provo Utah. Contact us at (214) 854-5638 for immediate assistance."
              }
            },
            {
              "@type": "Question",
              "name": "Do you pay above scrap prices for valves in Provo?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we pay fair market prices well above scrap value for quality Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves in Provo Utah."
              }
            }
          ]
        },
        {
          "@type": "WebPage",
          "name": "We Buy Surplus Valves Provo Utah - Fisher Valves Rosemount Transmitters",
          "description": "Professional buyers of Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves in Provo Utah. Serving Utah Valley manufacturing facilities.",
          "url": "https://valvesalessupply.com/provo"
        }
      ]
    });
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />

      {/* Breadcrumbs */}
      <section className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <nav className="flex items-center text-sm">
            <Link to="/" className="text-gray-600 hover:text-[#1B3A5F] transition-colors">
              Home
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400 mx-2"></i>
            <Link to="/service-areas" className="text-gray-600 hover:text-[#1B3A5F] transition-colors">
              Service Areas
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400 mx-2"></i>
            <Link to="/utah" className="text-gray-600 hover:text-[#1B3A5F] transition-colors">
              Utah
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400 mx-2"></i>
            <span className="text-[#1B3A5F] font-semibold">Provo</span>
          </nav>
        </div>
      </section>
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-b from-[#1B3A5F] to-[#2B4A6F]">
        <div className="max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-5xl font-bold mb-6">We Buy Surplus Valves Provo Utah - Fisher Valves Rosemount Transmitters</h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Premier buyers of Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves serving Provo and Utah Valley manufacturing facilities, technology companies, and regional industrial operations.
          </p>
        </div>
      </section>

      {/* Quick Contact Bar */}
      <section className="bg-white py-6 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center">
              <i className="ri-map-pin-line text-[#1B3A5F] text-2xl mr-3"></i>
              <span className="text-gray-700 font-semibold">Serving Provo &amp; Utah Valley</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-[#1B3A5F] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#2B4A6F] transition-all duration-300 flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                (214) 854-5638
              </a>
              <a
                href="mailto:provo@valvesalessupply.com"
                className="border-2 border-[#1B3A5F] text-[#1B3A5F] px-6 py-3 rounded-full font-semibold hover:bg-[#1B3A5F] hover:text-white transition-all duration-300 flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                Email Provo Team
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Market Overview */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">
                Surplus Valve Buyers Provo Utah - Fisher Control Valves Rosemount Equipment
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Valve Sales Supply provides professional equipment purchasing services to Provo's 
                growing industrial sector, including advanced manufacturing facilities, technology 
                companies, and regional industrial operations throughout Utah Valley. We specialize in buying Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves from Provo manufacturing facilities.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Our team specializes in acquiring surplus Fisher valves, Rosemount instrumentation, and process control 
                equipment from facility upgrades, plant closures, and equipment modernization projects 
                across the region's diverse manufacturing and technology base in Provo Utah.
              </p>
              <div className="grid md:grid-cols-2 gap-4">
                {[
                  'Same-Day Response',
                  '24-Hour Quotes',
                  'Professional Removal',
                  'Fair Market Pricing',
                  'Complete Documentation',
                  'Licensed &amp; Insured'
                ].map((feature, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3 text-xl"></i>
                    <span className="text-gray-700 font-semibold">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="rounded-3xl overflow-hidden shadow-lg">
              <img 
                src="https://public.readdy.ai/ai/img_res/091c9e1429fdbd86bb73325797e05162.jpg"
                alt="Provo Industrial Area"
                className="w-full h-96 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Fisher Control Valves Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              We Buy Fisher Valves Rosemount Transmitters Safety Relief Valves Provo Utah
            </h2>
            <p className="text-gray-600 text-xl">
              Professional buyers of all major valve and instrumentation brands in Provo
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <div className="w-16 h-16 bg-[#1B3A5F] rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-settings-3-line text-white text-2xl"></i>
              </div>
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">Fisher Control Valve Buyers Provo Utah - Fisher EZ ED HP DVC6000</h3>
              <p className="text-gray-700 mb-4">
                We buy all Fisher control valves in Provo Utah including Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000, Fisher 657, Fisher 667, and all Fisher valve models from Utah Valley manufacturing facilities.
              </p>
              <ul className="space-y-2">
                {[
                  'Fisher EZ Control Valves',
                  'Fisher ED Control Valves',
                  'Fisher HP Control Valves',
                  'Fisher DVC6000 Positioners',
                  'Fisher 657 Actuators',
                  'Fisher 667 Actuators',
                  'All Fisher Valve Models'
                ].map((item, index) => (
                  <li key={index} className="flex items-center text-gray-700">
                    <i className="ri-check-line text-[#1B3A5F] mr-2"></i>
                    <strong>{item}</strong>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <div className="w-16 h-16 bg-[#1B3A5F] rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-dashboard-line text-white text-2xl"></i>
              </div>
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">Rosemount Transmitter Buyers Provo Utah - Rosemount 3051 2088 644 8800</h3>
              <p className="text-gray-700 mb-4">
                We buy all Rosemount transmitters in Provo Utah including Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800, and all Rosemount instrumentation from Utah Valley facilities.
              </p>
              <ul className="space-y-2">
                {[
                  'Rosemount 3051 Transmitters',
                  'Rosemount 2088 Transmitters',
                  'Rosemount 644 Transmitters',
                  'Rosemount 8800 Vortex Meters',
                  'Rosemount Pressure Transmitters',
                  'Rosemount Flow Meters',
                  'All Rosemount Models'
                ].map((item, index) => (
                  <li key={index} className="flex items-center text-gray-700">
                    <i className="ri-check-line text-[#1B3A5F] mr-2"></i>
                    <strong>{item}</strong>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="bg-[#F5F7FA] rounded-3xl p-8">
            <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6 text-center">Safety Relief Valve Buyers Provo Utah - Pipeline Valve Buyers</h3>
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h4 className="text-[#1B3A5F] text-xl font-bold mb-4">Safety Relief Valves Provo</h4>
                <ul className="space-y-2">
                  {[
                    'Crosby Safety Relief Valves',
                    'Anderson Greenwood Relief Valves',
                    'Consolidated Safety Valves',
                    'Leser Safety Valves',
                    'Farris Relief Valves',
                    'Dresser Safety Valves'
                  ].map((item, index) => (
                    <li key={index} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-[#1B3A5F] mr-2"></i>
                      <strong>{item}</strong>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-[#1B3A5F] text-xl font-bold mb-4">Pipeline Valves Provo</h4>
                <ul className="space-y-2">
                  {[
                    'Cameron Ball Valves',
                    'Velan Gate Valves',
                    'WKM Ball Valves',
                    'Grove Ball Valves',
                    'Powell Gate Valves',
                    'All Pipeline Valve Brands'
                  ].map((item, index) => (
                    <li key={index} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-[#1B3A5F] mr-2"></i>
                      <strong>{item}</strong>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Major Facilities Served */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Provo Facilities We Serve
            </h2>
            <p className="text-gray-600 text-xl">
              Supporting Utah Valley's manufacturing and technology sectors
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                name: 'Advanced Manufacturing',
                type: 'Manufacturing',
                icon: 'ri-tools-line',
                description: 'Precision manufacturing and fabrication'
              },
              {
                name: 'Technology Companies',
                type: 'Tech Manufacturing',
                icon: 'ri-cpu-line',
                description: 'Electronics and technology production'
              },
              {
                name: 'Food Processing Plants',
                type: 'Food Manufacturing',
                icon: 'ri-restaurant-line',
                description: 'Regional food processing facilities'
              },
              {
                name: 'Chemical Processing',
                type: 'Chemical Manufacturing',
                icon: 'ri-flask-line',
                description: 'Specialty chemical production'
              },
              {
                name: 'Industrial Parks',
                type: 'Mixed Industrial',
                icon: 'ri-building-line',
                description: 'Various industrial operations'
              },
              {
                name: 'Water Treatment',
                type: 'Municipal Infrastructure',
                icon: 'ri-drop-line',
                description: 'Regional water facilities'
              }
            ].map((facility, index) => (
              <div key={index} className="bg-white rounded-3xl p-6">
                <div className="w-16 h-16 bg-[#1B3A5F] rounded-2xl flex items-center justify-center mb-4">
                  <i className={`${facility.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-2">{facility.name}</h3>
                <p className="text-gray-600 font-semibold mb-2">{facility.type}</p>
                <p className="text-gray-600 text-sm">{facility.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Equipment We Purchase in Provo
            </h2>
            <p className="text-gray-600 text-xl">
              Comprehensive industrial equipment purchasing services
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: 'Process Valves',
                icon: 'ri-settings-3-line',
                items: ['Ball Valves', 'Gate Valves', 'Butterfly Valves', 'Check Valves']
              },
              {
                title: 'Instrumentation',
                icon: 'ri-dashboard-line',
                items: ['Pressure Gauges', 'Flow Meters', 'Level Sensors', 'Transmitters']
              },
              {
                title: 'Control Systems',
                icon: 'ri-cpu-line',
                items: ['PLCs', 'HMIs', 'Controllers', 'Actuators']
              },
              {
                title: 'Safety Equipment',
                icon: 'ri-shield-check-line',
                items: ['Relief Valves', 'Safety Valves', 'Gas Detection', 'Alarms']
              }
            ].map((category, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-3xl p-6">
                <div className="w-16 h-16 bg-[#1B3A5F] rounded-2xl flex items-center justify-center mb-4">
                  <i className={`${category.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{category.title}</h3>
                <ul className="space-y-2">
                  {category.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-[#1B3A5F] mr-2"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Advantages */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Why Provo Facilities Choose Us
            </h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: 'Regional Expertise',
                icon: 'ri-map-pin-line',
                description: 'Comprehensive understanding of Utah Valley\'s manufacturing and technology sectors with specialized knowledge of regional equipment standards.'
              },
              {
                title: 'Fast Response',
                icon: 'ri-time-line',
                description: 'Same-day site visits throughout Provo and Utah Valley with 24-hour quotes for all equipment types and project sizes.'
              },
              {
                title: 'Professional Service',
                icon: 'ri-award-line',
                description: 'Licensed, insured, and experienced team handling everything from small instrument lots to complete facility decommissioning projects.'
              }
            ].map((advantage, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 text-center">
                <div className="w-20 h-20 bg-[#1B3A5F] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${advantage.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{advantage.title}</h3>
                <p className="text-gray-600 leading-relaxed">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Related Markets */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Other Utah Markets We Serve
            </h2>
            <p className="text-gray-600 text-xl">
              Comprehensive coverage across Utah
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-8">
            <Link
              to="/salt-lake-city"
              className="bg-[#F5F7FA] rounded-2xl p-6 hover:shadow-lg transition-all duration-300 flex items-center justify-between group"
            >
              <div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-1">Salt Lake City</h3>
                <p className="text-gray-600">Northern Utah Industrial Hub</p>
              </div>
              <i className="ri-arrow-right-line text-[#1B3A5F] text-2xl group-hover:translate-x-2 transition-transform"></i>
            </Link>
          </div>

          <div className="text-center">
            <Link
              to="/utah"
              className="inline-flex items-center text-[#1B3A5F] font-semibold text-lg hover:underline"
            >
              View All Utah Cities
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-white text-4xl font-bold mb-6">
            Sell Surplus Valves Provo Utah - Contact Provo Utah Valve Buyers
          </h2>
          <p className="text-gray-200 text-xl mb-10">
            Fast, professional service for all your surplus Fisher valves, Rosemount transmitters, and equipment needs in Utah Valley
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link
              to="/contact"
              className="bg-white text-[#1B3A5F] px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 whitespace-nowrap"
            >
              REQUEST A QUOTE
            </Link>
            <a
              href="tel:214-854-5638"
              className="border-2 border-white text-white px-10 py-4 rounded-full text-xl font-semibold hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 flex items-center justify-center whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              (214) 854-5638
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Provo;
